import clsx from 'clsx';
import React from 'react';

import PowerlistRow from './PowerlistRow';
import styles from './styles.module.css';

const PowerlistSection = ({
  details,
  handleClose,
  handlePersonClick,
  section,
  sectionNum,
  title,
}) => {
  return (
    <div className="col-sm-10 col-sm-offset-1 mt2">
      <div className="title-container">
        <div className="section-title">{title}</div>
        <div className={styles.titleUnderline}></div>
      </div>
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(0, 3)}
        rowNum={`${sectionNum}.1`}
      />
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(3, 5)}
        rowNum={`${sectionNum}.2`}
      />
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(5, 8)}
        rowNum={`${sectionNum}.3`}
      />
      <PowerlistRow
        details={details}
        handleClose={handleClose}
        handlePersonClick={handlePersonClick}
        row={section.slice(8)}
        rowNum={`${sectionNum}.4`}
      />
      {sectionNum === 3 && (
        <div className="reference-row">
          <div className={clsx(styles.referenceNotes, 'reference-notes')}>
            Data are of Aug 8, 2022. Interactive by Haejin Park, Mack Cooper and Mike Sullivan.
            {'\n'}
            Typography by Justin Bihan via VTF
          </div>
        </div>
      )}
    </div>
  );
};

export default PowerlistSection;
